export const usmle1GeneticsModule = {
  id: "genetics",
  title: "Genetics",
  sections: [
    {
      type: "text",
      content:
        "Autosomal dominant: vertical transmission. Autosomal recessive: horizontal pattern, consanguinity risk.",
    },
    {
      type: "question",
      text: "Which inheritance pattern shows vertical transmission?",
      options: ["Autosomal dominant", "Autosomal recessive", "X-linked recessive", "Mitochondrial"],
      correct: 0,
      explanation: "Autosomal dominant disorders classically show vertical transmission.",
    },
  ],
};
